<template>
  <pt-policy-form class="pt-policy-form__page" :isEdit="is_edit" :id="id" :policyType="policyType"
  :isIntegral="is_integral"></pt-policy-form>
</template>

<script>
import PtPolicyForm from 'cps/other-service/pt-policy-manage/pt-policy-form'
export default {
  name: 'pt-policy-form__view',
  components: {
    'pt-policy-form': PtPolicyForm
  },
  props: {
    isEdit: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    },
    policyType: {
      type: String,
      default: ''
    },
    isIntegral: {
      type: String
    }
  },
  data () {
    return {
      is_edit: this.isEdit === 'true',
      is_integral: this.isIntegral === 'true'
    }
  }
}
</script>
